// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-ticket{display:flex;flex-direction:column;justify-content:center;align-items:center;width:100%}.edit-ticket input,.edit-ticket label,.edit-ticket textarea{width:40%}button{width:20%;margin-top:20px;height:40px;cursor:pointer;border-radius:10px;border:none;background-color:#20b2aa;color:#fff}button:hover{background-color:#fff;color:#20b2aa;border:1px solid #20b2aa}", ""]);
// Exports
module.exports = exports;
